/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TGetPaymentStatusModel = IModel<IGetPaymentStatusRequest, TGetPaymentStatusResponse>;

export interface IGetPaymentStatusRequest {
  /** Айди транзакции **/
  transactionId: string;
}

export type TGetPaymentStatusResponse = IGetPaymentStatusResponse200 | IGetPaymentStatusResponse400;

export interface IGetPaymentStatusResponse200 extends IModelResponse<IGetPaymentStatusResponse> {
  statusCode: 200;
}

export interface IGetPaymentStatusResponse400 extends IModelResponse<IGetPaymentStatusResponseError> {
  statusCode: 400;
}

export interface IGetPaymentStatusResponse {
  /** Статус оплаты **/
  paymentStatus: EPaymentStatus;
  /** Урл оплаты в юкассе **/
  paymentUrl: string;
  /** Адрес объекта **/
  propertyAddress: string;
  /** Название объекта **/
  propertyName: string;
  /** Емейл который пользователь указалал при покупку отчета **/
  userEmail: string;
}

export interface IGetPaymentStatusResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetPaymentStatusResponse | IGetPaymentStatusResponseError;

export enum EPaymentStatus {
  /** Отмена **/
  Canceled = 'canceled',
  /** Ошибка **/
  Error = 'error',
  /** Ожидает оплату **/
  Pending = 'pending',
  /** Успех **/
  Success = 'success',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetPaymentStatusResponse): TResponse200;
  400(response: IGetPaymentStatusResponseError): TResponse400;
}
